import 'styles/age_gate/age_gate.scss';

import { mount } from '../apps/age_gate';

const root = document.querySelector('#js-age-gate-root');
const ageGateData = JSON.parse(root.dataset.ageGate);

mount('js-age-gate-root', ageGateData);
